/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import { LocationType } from '../../model/LocationType';
import { LocationTypesService } from '../../services/location-types.service';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-location-type',
    templateUrl: './location-type.component.html',
    standalone: false
})
export class LocationTypeComponent extends BaseMessageComponent implements OnInit {
    public locationTypes: LocationType[];
    public indexWithChanges: number[] = [];

    constructor(
        private locationTypeService: LocationTypesService,
        private spinnerService: NgxSpinnerService,
        cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        this.getLocationTypes();
    }

    public addNew(locationType: string): void {
        this.spinnerService.show();

        var newLocationType = new LocationType();
        newLocationType.locationType = locationType;

        this.locationTypeService.addNew(newLocationType).subscribe(value => {
            this.locationTypes = null;
            this.getLocationTypes();
        },
            (error) => {
                console.error(error);
              if (error.status=='409')
                alert("Duplicate Value(s) found.");
              else
                alert(error.message);
                this.spinnerService.hide();
            },
            () => {
                this.spinnerService.hide();
            });
    }

    public saveChanges(): void {
        this.spinnerService.show();

        if (this.indexWithChanges.length > 0) {
            for (var i = 0; i < this.indexWithChanges.length; i++) {
                var idx = this.indexWithChanges[i];
                this.locationTypeService.updateLocationTypes(this.locationTypes[idx]).subscribe(value => {
                    console.log(this.locationTypes[idx] + " saved.")
                },
                    (error) => {
                        this.spinnerService.hide();
                        console.error(error);
                      if (error.status=='409')
                        alert("Duplicate Value(s) found.");
                      else
                        alert(error.message);
                    },
                    () => {
                        this.spinnerService.hide();
                        this.indexWithChanges = [];
                    });
            }
            setTimeout(() => {
                this.getLocationTypes();
            }, 3000);
        } else {
          this.spinnerService.hide();
          alert("No changes to save.");
        }
    }

    public updateIndexes(index): void {
        if (this.indexWithChanges.indexOf(index) === -1) {
            this.indexWithChanges.push(index);
        }
        console.log(this.indexWithChanges);
    }

    private getLocationTypes(): void {
        this.locationTypeService.getAll().subscribe(
            locationTypes => {
                this.locationTypes = locationTypes;
                this.cdr.detectChanges();
            }
        )
    }
}
